import React, { useState, memo, useEffect , useRef } from 'react';
import "./styles.scss";
import ModelNew from 'Components/Model/ModelNew';
import CloseButton from 'Components/CloseButton';
import ForgotPassword from "Components/Header/ForgotPassword";
import { useDispatch, useSelector} from 'react-redux';
import { closeLoginForgot } from 'Utilities';
import Login from '../Login/Login';
import { useSearchParams , useNavigate } from 'react-router-dom';

const LoginForgot = () => {
    const openForgotPassword = useSelector((state) => state?.openForgotPassword);
    const openLogin = useSelector((state) => state?.openLogin);
    const getUrlType = useSelector((state) => state?.getUrlType);
    const wilistProductId = useSelector((state) => state?.wilistProductId?.id);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [resMessage, setResMessage] = useState("");
    const [loginForgot, setLoginForgot] = useState(true);
    const popupRef = useRef();

    useEffect(() => {
        if (resMessage) setResMessage("");
    }, [openLogin]);

    const handleClose = () => {
        const params = new URLSearchParams(searchParams);
        params.delete('forgetpassword');
        params.delete('login');
        navigate({ search: params.toString() }, { replace: true });
        closeLoginForgot(dispatch);
      };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        handleClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchParams]);

    return (
        <ModelNew
            from="right"
            hideScroll={false}
            zindex={11}
            openGlobal={openLogin ? openLogin : openForgotPassword}
            shadow={true}
            setGlobalAction={() => closeLoginForgot(dispatch)}
            className="header__login__sidebar"
        >
            <div className="sidebar__login w-1/1 h-1/1 px-4 sm-px-6 py-4 overflow-hidden overflow-y-auto" ref={popupRef}>
                <div className="close__block tr flex right w-1/1">
                    <CloseButton onClickFunction={handleClose} />
                </div>
                {
                    (openLogin && !openForgotPassword) ?
                        <Login resMessage={resMessage} setResMessage={setResMessage} getUrlType={getUrlType} wilistProductId={wilistProductId} />
                        : <></>
                }
                {
                    (!openLogin && openForgotPassword) ?
                        <ForgotPassword loginForgot={loginForgot} setLoginForgot={setLoginForgot} setResMessages={setResMessage} />
                        : <></>
                }
            </div>
        </ModelNew>
    )
}

export default memo(LoginForgot);